import { render, staticRenderFns } from "./InfoBeamsPopup.vue?vue&type=template&id=5ddd1622&scoped=true&"
import script from "./InfoBeamsPopup.vue?vue&type=script&lang=js&"
export * from "./InfoBeamsPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoBeamsPopup.vue?vue&type=style&index=0&id=5ddd1622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd1622",
  null
  
)

export default component.exports